"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const bcp_1 = require("@iov/bcp");
const encoding_1 = require("@iov/encoding");
const tendermint_rpc_1 = require("@iov/tendermint-rpc");
const decode_1 = require("./decode");
const encode_1 = require("./encode");
const codecImpl = __importStar(require("./generated/codecimpl"));
const util_1 = require("./util");
exports.bnsCodec = {
    // these are the bytes we create to add a signature
    // they often include nonce and chainID, but not other signatures
    bytesToSign: (tx, nonce) => {
        // we encode it without any signatures
        const built = encode_1.buildUnsignedTx(tx);
        const bz = codecImpl.bnsd.Tx.encode(built).finish();
        // now we want to append the nonce and chainID
        const bytes = util_1.appendSignBytes(bz, tx.creator.chainId, nonce);
        return { bytes: bytes, prehashType: bcp_1.PrehashType.Sha512 };
    },
    // bytesToPost includes the raw transaction appended with the various signatures
    bytesToPost: (tx) => {
        const built = encode_1.buildSignedTx(tx);
        const out = new Uint8Array(codecImpl.bnsd.Tx.encode(built).finish());
        return out;
    },
    // identifier is usually some sort of hash of bytesToPost, chain-dependent
    identifier: (tx) => {
        const transactionBytes = exports.bnsCodec.bytesToPost(tx);
        const hash = tendermint_rpc_1.v0_31.hashTx(transactionBytes);
        return encoding_1.Encoding.toHex(hash).toUpperCase();
    },
    // parseBytes will recover bytes from the blockchain into a format we can use
    parseBytes: (bz, chainId) => {
        const parsed = codecImpl.bnsd.Tx.decode(bz);
        return decode_1.parseTx(parsed, chainId);
    },
    identityToAddress: util_1.identityToAddress,
    isValidAddress: util_1.isValidAddress,
};
//# sourceMappingURL=bnscodec.js.map